import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthService from "../../services/auth.service";
import EmployerPlanService from "../../services/employerplan.service";
import EmployerService from "../../services/employer.service";

export const getemployershortPlans = createAsyncThunk(
    "plan/employer/getemployerplan",
    async ( thunkAPI) => {
        try {
            const data = await EmployerPlanService.getEmployershortPlans();
            return { user: data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue({ message });
        }
    }
);

export const getemployerLongPlans = createAsyncThunk(
    "plan/employer/getemployerplan",
    async ( thunkAPI) => {
        try {
            const data = await EmployerPlanService.getEmployerLongPlans();
            return { user: data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue({ message });
        }
    }
);


//for initiating employer payment
export const EmployerInitiatePayment = createAsyncThunk(
    "plan/employer/initiatepaymens",
    async ( item,thunkAPI) => {
        try {
            const data = await EmployerPlanService.employerIntiatePayment(item);
            return { user: data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue({ message });
        }
    }
);

export const EmployerPlanInitiatePayment = createAsyncThunk(
    "plan/employer/planinitiatepaymens",
    async ( item,thunkAPI) => {
        try {
            const data = await EmployerPlanService.employerPlanIntiatePayment(item);
            return { user: data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue({ message });
        }
    }
);

//for purchaging plan
export const EmployerAssistance = createAsyncThunk(
    "plan/employer/assistance",
    async ( item,thunkAPI) => {
        try {
            const data = await EmployerPlanService.purchageAssistance(item);
            return { user: data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue({ message });
        }
    }
);


const initialState = {
    loading: false,
    error: "",
    empPlandata: AuthService.getUserDetails() || null,
    isLoggedIn: false,
};

const employerPlanSlice = createSlice({
    name: "employerplan",
    initialState,
    extraReducers: {
        [getemployershortPlans.pending]: (state) => {
            state.loading = true;
            state.error = "";
            state.isLoggedIn = false;
            state.empPlandata = null;
        },
        [getemployershortPlans.fulfilled]: (state, action) => {
            state.loading = false;
            state.error = "";
            state.isLoggedIn = true;
            state.empPlandata = action.payload.user;
        },
        [getemployershortPlans.rejected]: (state, action) => {
            state.loading = false;
            state.error = action.payload.message;
            state.isLoggedIn = false;
            state.empPlandata = null;
        },
       

        // [logout.fulfilled]: (state, action) => {
        //     state.isLoggedIn = false;
        //     state.user = null;
        // },
    },
});

const { reducer } = employerPlanSlice;
export default reducer;